var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-notice"},[_c('event-detail-title',{attrs:{"type":_vm.anchorMap.NOTICE_KEY}}),_c('div',{staticClass:"section-content"},[_c('markdown-beautiful',{attrs:{"data":_vm.events_notice_html}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }